import { IInstrument, IRealPrice } from '../types';

export const initialRealPrice: IRealPrice = {
  ask: '0',
  bid: '0',
  currentPrice: '0',
};

export const initialInstrument: IInstrument = {
  general: {
    symbol: '',
    step: 0,
    fixDigitAfterDot: 0,
    description: '',
    id: 0,
    tradingStatus: '',
    currency: '',
    pipSize: 0,
    isFavorite: false,
    isOpenTrading: false,
    leverage: 0,
    close: 0,
    open: 0,
    stopsLevel: 0,
    category: '',
    swapRateLong: 0,
    swapRateShort: 0,
    spreadDiff: 0,
    displayName: '',
    currencySymbol: '',
    iconUrl: '',
    tradingHours: [],
    high: 0,
    low: 0,
  },
  market: {
    billType: 'Buy',
    amountVolume: '',
    valueVolume: '',
    reqMarginValue: 0,
    minAmountValue: 0,
    maxAmountValue: 0,
    protection: {
      lossValue: '',
      profitValue: '',
      minValue: 0,
      maxValue: 0,
      isSwitchLoss: false,
      isSwitchProfit: false,
      unitStopLoss: 'Rate',
      unitProfit: 'Rate',
      profitPips: '0',
      stopLossPips: '0',
      stopsLevel: 0,
    },
  },
  limit: {
    billType: 'Buy',
    buyValue: '',
    sellValue: '',
    amount: '',
    value: '',
    reqMargin: 0,
  },
};
